import {
  ApiNewDokumentPowiazanyDalDto,
  EgibObject,
  Place,
  Street,
} from '@gk/gk-modules';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { WorkspaceState } from '../../../../services/request-workspace-state/request-workspace-state.model';
import {
  DocumentationFormType,
  ExtendedApplicantRequest,
  ExtendedApplicantRequestDto,
} from '../../../../shared/base-new-request/base-new-request.model';
import { InvestorDetails } from '../../../../shared/investor-details/investor-details.model';
import { Shipping } from '../../../../shared/shipping-form/shipping-form.model';
import {
  ApiTimeString,
  DateHelperUtil,
  NgbDateRange,
} from '../../../../utils/date-helper/date-helper.util';

export interface PLNewRequestDto extends ExtendedApplicantRequestDto {
  DataOd: string;
  MiejscId?: string | number;
  Miejsc?: string;
  UlicaId?: string | number;
  Ulica?: string;
  CelDzierzawy?: string;
  Powierzchnia?: string;
  DataDo?: string;
  InfoDodatkowe?: string;
  NrUmowy?: string;
  AneksDotyczy?: string;
}

export class PLNewRequest extends ExtendedApplicantRequest {
  constructor(
    investorDetails: InvestorDetails,
    public purpose: string,
    public leaseDate: NgbDateRange,
    public place: Place,
    public street: Street,
    public areaToLease: string,
    documentationForm: DocumentationFormType,
    shippingForm: Shipping,
    public comments: string,
    proxyDetailsCheckbox: boolean,
    proxyDetailsArray: InvestorDetails[],
    public anexDateFrom?: NgbDate,
    public anexDescription?: string,
    public leaseNumber?: string,
  ) {
    super(
      investorDetails,
      documentationForm,
      shippingForm,
      undefined,
      undefined,
      proxyDetailsCheckbox,
      proxyDetailsArray,
    );
  }

  static fromAppToApi(
    data: PLNewRequest,
    issueRanges: string[],
    parcels: EgibObject[],
    files: ApiNewDokumentPowiazanyDalDto[],
  ): PLNewRequestDto {
    const isNewMode = data.requestMode === PLRequestMode.New;
    const isAnexMode = data.requestMode === PLRequestMode.Annex;
    return {
      ...ExtendedApplicantRequest.mapCommonFields({
        data,
        issueRanges,
        parcels: isNewMode ? parcels : [],
        files,
      }),
      ...(isNewMode
        ? {
            MiejscId: data.place && data.place.id,
            Miejsc: data.place && data.place.name,
            UlicaId: data.street && data.street.id,
            Ulica: data.street && data.street.name,
            DataDo: data.leaseDate?.to
              ? DateHelperUtil.ngbDateToApiDateTime(
                  data.leaseDate.to,
                  ApiTimeString.End,
                )
              : undefined,
            CelDzierzawy: data.purpose,
            Powierzchnia: data.areaToLease,
            InfoDodatkowe: data.comments,
          }
        : {}),
      ...(isAnexMode
        ? {
            AneksDotyczy: data.anexDescription,
            NrUmowy: data.leaseNumber,
          }
        : {}),
      DataOd: data.requestMode
        ? DateHelperUtil.ngbDateToApiDateTime(
            isNewMode ? data.leaseDate?.from : data.anexDateFrom,
          )
        : undefined,
    };
  }
}

export interface PLNewRequestFormWorkspaceState extends WorkspaceState {
  formValue: PLNewRequest;
  parcels: EgibObject[];
  issueRanges: string[];
}

export enum PLRequestMode {
  New = 3,
  Annex = 4,
}
